var detailPage={
    xwzx:{
        crumbsName:'News',
        pageType:'news'
    },
    fgsf:{
        crumbsName:'The Voice of Judge',
        pageType:'the-voice-of-judge'
    },
    flfg:{
        crumbsName:'Laws&Regulations',
        pageType:'laws-regulations'
    },
    fyjj:{
        crumbsName:'About us',
        pageType:'about-the-court'
    },
    cpws:{
        crumbsName:'Judgement',
        pageType:'judgement'
    },
    dxal:{
        crumbsName:'Typical cases',
        pageType:'case-abstract'
    },
    bps:{
        crumbsName:'White Papers',
        pageType:'annual-report'
    },
    xsjl:{
        crumbsName:'Academic Communication',
        pageType:'acadmic-communication'
    }
}

const hsfyMap= [
    {
        sf:'广西',
        fymc:'BEIHAI MARITIME COURT OF PRC'
    },
    {
        sf:'辽宁',
        fymc:'DALIAN MARITIME COURT OF PRC'
    },
    {
        sf:'广东',
        fymc:'GUANGZHOU MARITIME COURT OF PRC'
    },
    {
        sf:'海南',
        fymc:'HAIKOU MARITIME COURT OF PRC'
    },
    {
        sf:'江苏',
        fymc:'NANJING MARITIME COURT OF PRC'
    },
    {
        sf:'浙江',
        fymc:'NINGBO MARITIME COURT OF PRC'
    },
    {
        sf:'山东',
        fymc:'QINGDAO MARITIME COURT OF PRC'
    },
    {
        sf:'福建',
        fymc:'XIAMEN MARITIME COURT OF PRC'
    },
    {
        sf:'上海',
        fymc:'SHANGHAI MARITIME COURT OF PRC'
    },
    {
        sf:'天津',
        fymc:'TIANJIN MARITIME COURT OF PRC'
    },
    {
        sf:'湖北',
        fymc:'WUHAN MARITIME COURT OF PRC'
    }
]

const commons = {

    //获取uuid
    getUuid: function () {
        var d = new Date().getTime();
        var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16).toUpperCase();
        });
        return uuid.toUpperCase();
    },
    // 查询列表
    requestList: function(param) {
        // 设置开始时间
        const _startTime = window.fdGlobal.performance.getCurrentTime();
        return new Promise((resolve, reject) => {
            const _showLog = this.showLog;
            const _name = '【获取列表数据】';
            const _method = window.fdConfig.methodGet;
            const _url = window.fdConfig.url.common.list;
            const _data = param;
            // 输出日志
            window.fdGlobal.consoleLogRequest(_showLog, _name, _method, _url, _data);
            //  返回shuju
            window.fdGlobal.ajax({
                method: _method,
                url: _url,
                params: _data,
                responseType: 'json'
            }).then((data) => {
                const _serverData = data.data;
                window.fdGlobal.performance.execute(`${_name}ajax 结束时间，拿到数据的时间 :`, _startTime);
                // 后端输出日志
                window.fdGlobal.consoleLogResponse(_showLog, _name, _serverData);
                resolve(_serverData);
            }, (data) => {
                reject(data);
            });
        });
    },
    // 统计数据查询
    requestStatistics: function(tjlx,tjsj) {
        // 设置开始时间
        const _startTime = window.fdGlobal.performance.getCurrentTime();
        return new Promise((resolve, reject) => {
            const _showLog = this.showLog;
            const _name = '【获取统计数据】';
            const _method = window.fdConfig.methodGet;
            let _url = '';
            if (tjlx === 'sp') {
                _url = window.fdConfig.url.statistics.sp;
            } else if (tjlx === 'zx') {
                _url = window.fdConfig.url.statistics.zx;
            } else if (tjlx === 'sw') {
                _url = window.fdConfig.url.statistics.sw;
            } else if (tjlx === 'gat') {
                _url = window.fdConfig.url.statistics.gat;
            }

            if(!tjsj){
                tjsj= new Date().getFullYear().toString();
            }
            const _data = {};
            _data.tjsj = tjsj;
            // 输出日志
            window.fdGlobal.consoleLogRequest(_showLog, _name, _method, _url, _data);
            //  返回shuju
            window.fdGlobal.ajax({
                method: _method,
                url: _url,
                params: _data,
                responseType: 'json'
            }).then((data) => {
                const _serverData = data.data;
                window.fdGlobal.performance.execute(`${_name}ajax 结束时间，拿到数据的时间 :`, _startTime);
                // 后端输出日志
                window.fdGlobal.consoleLogResponse(_showLog, _name, _serverData);
                resolve(_serverData);
            }, (data) => {
                reject(data);
            });
        });
    },
    commonDetail: function(_this,param){
        let querys = {
            crumbsName: detailPage[param.mklx].crumbsName,
            pageType: detailPage[param.mklx].pageType,
            bh: param.bh
        };
        const {href} = _this.$router.resolve({path:`/${querys.pageType}/detail`, query: querys});
        window.open(href, '_blank');
    },
    fyHsfy: function(list){
        for (var i=0; i<list.length; i++) {
            for (var j=0; j<hsfyMap.length; j++) {
                if (hsfyMap[j].sf === list[i].name) {
                    list[i].title = hsfyMap[j].fymc;
                }
            }
        }
    }
};
// });
// 如果是模块化的，请注释下面的这行代码
// 2019-06-04 todo
export default commons;
